import axios from 'axios';
import { axiosConfig } from '../config';
import { AUTH_LOGIN_URI } from '../constants';
import ERRORS from '../../constants/errors';
import * as I from '../../models/auth';

export const customerLogin = async ({
  email,
  password,
}: I.LoginRequest): Promise<I.LoginResponse> => {
  try {
    const res = await axios.post(
      AUTH_LOGIN_URI,
      {
        email,
        password,
      },
      axiosConfig
    );
    const { data } = res;
    return data;
  } catch (error) {
    return {
      token: '',
      refreshToken: '',
      error: error.response.data.Message,
      code: error.response.data.StatusCode,
    };
  }
};
export const getRefreshToken = async ({
  token,
  refreshToken,
  email
}: I.RefreshRequest): Promise<I.LoginResponse> => {
  try {
    const res = await axios.post(
      AUTH_LOGIN_URI,
      {
        token,
        refreshToken,
        email
      },
      axiosConfig
    );
    const { data } = res;
    return data;
  } catch (error) {
    return {
      token: '',
      refreshToken: '',
      error: error.message,
      code: error.response.data.StatusCode,
    };
  }
};
export const getUserInfo = async () : Promise<I.CustomerUserResponse> => {
  try {
    const res = await axios.get(
      AUTH_LOGIN_URI,
      axiosConfig
    );
    const { data } = res;
    return data;
  } catch (error) {
    return {
      displayName: '',
      role: '',
      email: '',
      error: error.message,
      code: error.response.data.StatusCode
    };
  }
};